import FancyIconCircle from '../fancy-icon-circle/component-lib.esm.js';
import { computed } from 'vue';
import tinycolor from 'tinycolor2';

//
var script = {
  components: {
    FancyIconCircle
  },
  props: {
    position: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const styles = computed(() => {
      const {
        top,
        left
      } = props.position;
      const color = tinycolor('#000').setAlpha(0.65);
      if (!top || !left) {
        return {
          '--c-bg-color': color.toRgbString()
        };
      }
      return {
        '--c-bg-color': color.toRgbString(),
        top,
        left,
        transform: 'none'
      };
    });
    return {
      styles
    };
  }
};
export { script as default };